import type { ReceiptTemplate } from '../schema';

export const balenciagaTemplate: ReceiptTemplate = {
  id: 'balenciaga',
  name: 'Balenciaga Receipt',
  brand: 'BALENCIAGA',
  description: 'Luxury fashion receipt template inspired by Balenciaga stores',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 9,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: 'none',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'bal-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/balenciaga.png',
        logoData: '',
        logoWidth: 170,
        logoHeight: 60,
        businessName: '',
        businessNameFontSize: 22,
        addressLines: [
          'Monsterville',
          'The Mall at Monsterville',
          '1200 Dark Avenue',
          'Monsterville, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'bal-trans-info',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'bal-trans', label: 'Trans #: 28451', value: '' },
          { id: 'bal-store', label: 'Store: 83042', value: '' },
          { id: 'bal-cashier', label: 'Cashier: 91085623', value: '' },
          { id: 'bal-customer', label: 'Customer: MIKE WAZOWSKI', value: '' },
          { id: 'bal-cust-id', label: 'Customer ID: 79999001708844', value: '' },
        ],
        column2: [
          { id: 'bal-date', label: 'Date: 6/21/23 18:21:42', value: '' },
          { id: 'bal-register', label: 'Register: 2', value: '' },
          { id: 'bal-empty-1', label: '', value: '' },
          { id: 'bal-empty-2', label: '', value: '' },
          { id: 'bal-empty-3', label: '', value: '' },
        ],
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'bal-items-header',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'ITEM                 QTY.        PRICE    AMOUNT USD',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'solid',
        isBold: true,
      },
    },
    {
      id: 'bal-item-1',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: '850556WCB1            1        1,050.00      1,050.00',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: true,
      },
    },
    {
      id: 'bal-item-desc',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: '021 MEN S SHOES 44/44E 850556WCBF11081 - 1081 - 44E\nSalesperson: 91085623 (JAMES)',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
    {
      id: 'bal-divider-1',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 8,
      },
    },
    {
      id: 'bal-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 50,
        labelAlignment: 'right',
        lines: [
          { id: 'bal-subtotal', label: 'Subtotal', value: '1,050.00', isBold: false, isLarge: false, isInverted: false },
          { id: 'bal-tax', label: 'Tax', value: '0.00', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'bal-total-line',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 50,
        labelAlignment: 'right',
        lines: [
          { id: 'bal-total', label: 'Total(USD)', value: '1,050.00', isBold: true, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'bal-payment',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'bal-visa', label: 'VISA ****4144', value: '' },
        ],
        column2: [
          { id: 'bal-visa-amt', label: '', value: '1,050.00' },
        ],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'bal-item-count',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'SOLD ITEM COUNT = 1',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'bal-divider-2',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 4,
      },
    },
    {
      id: 'bal-tax-analysis',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Sales Tax Analysis\nCode      Taxable      Rate      Total       Tax\nLOCAL    1,050.00        0%   1,050.00      0.00',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'bal-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: 'nT11D17NRR1141383T4AXH7C',
        showValue: true,
        width: 0.8,
        height: 25,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'bal-return-policy',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Full price merchandise will be considered for exchange or store credit only, when returned within 30 days, in original condition and accompanied by the original sales receipt.\nAll sale merchandise is final sale. For further details, please refer to the Customer Service section of our website balenciaga.com.',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'bal-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Original Copy',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: true,
      },
    },
  ],
};
